<template>
  <section class="admin-page">

    <header class="admin-header">
      <h1>Membership Plans</h1>

      <button class="primary-btn" @click="showModal = true">
        Create Plan
      </button>
    </header>

    <!-- Plans Table -->
    <section class="card">
  <table>
    <thead>
      <tr>
        <th>Name</th>
        <th>Price</th>
        <th>Duration</th>
        <th>Audience</th>
        <th>Broadcasts</th>
        <th>Campaigns</th>
        <th>Boost</th>
        <th>Support</th>
        <th>Status</th>
        <th></th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="p in plans" :key="p.mplan_id">

        <td>
          <strong>{{ p.mplan_name }}</strong>
          <div class="sub">{{ p.mplan_code }}</div>
        </td>

        <td>₹{{ p.mplan_price }}</td>

        <td>{{ p.mplan_duration }}</td>

        <td>{{ p.mplan_audience_limit || "∞" }}</td>

        <td>{{ p.mplan_broadcast_limit_daily || "∞" }}</td>

        <td>{{ p.mplan_campaign_limit || "∞" }}</td>

        <td>
          <span v-if="p.mplan_discovery_boost === 'yes'" class="pill ok">
            Yes
          </span>
          <span v-else class="pill muted">
            No
          </span>
        </td>

        <td>
          <span v-if="p.mplan_priority_support === 'yes'" class="pill ok">
            Priority
          </span>
          <span v-else class="pill muted">
            Standard
          </span>
        </td>

        <td>
          <span :class="['status-pill', p.mplan_status]">
            {{ p.mplan_status }}
          </span>
        </td>

        <td>
          <button class="ghost-btn" @click="toggleStatus(p)">
            Toggle
          </button>
           <button style="margin-top: .5rem; background: #ecfdf5; color: #047857;" class="ghost-btn danger" @click="editNow(p)">
            Edit
          </button>
           <button style="margin-top: .5rem; color: #991b1b; background-color: #fee2e2;" class="ghost-btn danger" @click="delPlan(p)">
            Delete
          </button>
        </td>

      </tr>
    </tbody>
  </table>
</section>


    <!-- MODAL -->
   <div v-if="showModal" class="modal-overlay">

  <div class="modal-card">

    <h3>Create Membership Plan</h3>

    <!-- BASIC -->
    <input v-model="plan.mplan_name" placeholder="Plan Name (Starter / Pro)" />
    <input v-model="plan.mplan_code" placeholder="Plan Code (STARTER / PRO)" />

    <select v-model="plan.mplan_status">
      <option value="active">Active</option>
      <option value="disabled">Disabled</option>
    </select>

    <input v-model="plan.mplan_price" type="number" placeholder="Price" />

    <select v-model="plan.mplan_duration">
      <option value="monthly">Monthly</option>
      <option value="yearly">Yearly</option>
    </select>

    <!-- LIMITS -->
    <input v-model="plan.mplan_audience_limit" type="number" placeholder="Audience Limit" />
    <input v-model="plan.mplan_broadcast_limit_daily" type="number" placeholder="Broadcast Limit (Daily)" />
    <input v-model="plan.mplan_campaign_limit" type="number" placeholder="Campaign Limit" />

    <!-- FEATURES (Dynamic JSON Array) -->
    <div class="features-box">

      <label>Plan Features</label>

      <div v-for="(f, i) in features" :key="i" class="feature-row">
        <input v-model="features[i]" placeholder="Feature..." />
        <button class="remove-btn" @click="removeFeature(i)">✕</button>
      </div>

      <button class="add-feature-btn" @click="addFeature">
        + Add Feature
      </button>
    </div>

    <!-- FLAGS -->
    <input v-model="plan.mplan_discovery_boost" type="number" placeholder="Discovery Boost %" />
    
    <select v-model="plan.mplan_priority_support">
      <option value="yes">Priority Support - Yes</option>
      <option value="no">Priority Support - No</option>
    </select>


    <!-- ACTIONS -->
    <div class="modal-actions">
      <button class="ghost-btn" @click="closeModal">Cancel</button>
      <button class="primary-btn" @click="savePlan">Save Plan</button>
    </div>

  </div>

</div>


  </section>
</template>

<script>
import { createPlanApi, loadPlansApi,updatePlanStatus,delPlanApi } from "../apis/planapis";
import { useToast } from "vue-toastification";

export default {
  name: "AdminPlans",

  data() {
    return {
      showModal: false,
      loading: false,
      toast:null,
      plans: [],

      plan: {
        mplan_id: "",
        mplan_name: "",
        mplan_code: "",
        mplan_status: "active",
        mplan_price: "",
        mplan_duration: "monthly",

        mplan_audience_limit: "",
        mplan_broadcast_limit_daily: "",
        mplan_campaign_limit: "",

        mplan_features: "",

        mplan_discovery_boost: "",
        mplan_priority_support: "no",

        mplan_created_by: "",
        mplan_updated_by: ""
      },

      features: []
    };
  },

  mounted() {
    this.toast = useToast();
    
    const ldataRaw = sessionStorage.getItem("ldata");
    const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
    if(ldata!=null){
      this.plan.mplan_created_by = ldata.user_id;
      this.plan.mplan_updated_by = ldata.user_id;
    }
    this.loadPlans();
  },

  methods: {
    async toggleStatus(plan) {

      const res = await updatePlanStatus(plan.mplan_id,((plan.mplan_status==="active")?"deactive":"active"));

      if (!res.status) {
        this.toast.error(res.success || "Status update failed");
        return;
      }

      // ✅ Instant UI update (no reload needed)
      plan.mplan_status = (plan.mplan_status==="active")?"deactive":"active";

      this.toast.success("Plan status updated");
    }
    ,
    async editNow(plan1){
      this.plan = {
        mplan_id: plan1.mplan_id,

        mplan_name: plan1.mplan_name || "",
        mplan_code: plan1.mplan_code || "",
        mplan_status: plan1.mplan_status || "active",
        mplan_price: plan1.mplan_price || "",
        mplan_duration: plan1.mplan_duration || "monthly",

        mplan_audience_limit: plan1.mplan_audience_limit || "",
        mplan_broadcast_limit_daily: plan1.mplan_broadcast_limit_daily || "",
        mplan_campaign_limit: plan1.mplan_campaign_limit || "",

        mplan_features: plan1.mplan_features || "",

        mplan_discovery_boost: plan1.mplan_discovery_boost || "",
        mplan_priority_support: plan1.mplan_priority_support || "no",

        mplan_created_by: plan1.mplan_created_by || "",
        mplan_updated_by: plan1.mplan_updated_by || ""
      };

      this.features = plan1.mplan_features
  ? JSON.parse(plan1.mplan_features)
  : [];

      this.showModal = true;
    }
    ,
     async delPlan(plan) {

      const res = await delPlanApi(plan.mplan_id);

      if (!res.status) {
        this.toast.error(res.success || "Delete failed");
        return;
      }

  

      this.toast.success("Plan Deleted");
      this.loadPlans();
    }
    ,
    // ✅ Load Plans
    async loadPlans() {
      const res = await loadPlansApi();

      if (res.status) {
        this.plans = res.records || [];
      }
    },

    // ✅ Modal Controls
    openModal() {
      this.resetPlan();
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    },

    // ✅ Reset Form
    resetPlan() {
      this.plan = {
        mplan_id: "",
        mplan_name: "",
        mplan_code: "",
        mplan_status: "active",
        mplan_price: "",
        mplan_duration: "monthly",

        mplan_audience_limit: "",
        mplan_broadcast_limit_daily: "",
        mplan_campaign_limit: "",

        mplan_features: "",

        mplan_discovery_boost: "",
        mplan_priority_support: "no",

        mplan_created_by: "",
        mplan_updated_by: ""
      };

      const ldataRaw = sessionStorage.getItem("ldata");
      const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
      if(ldata!=null){
        this.plan.mplan_created_by = ldata.user_id;
        this.plan.mplan_updated_by = ldata.user_id;
      }

      this.features = [];
    },

    // ✅ Feature Engine
    addFeature() {
      this.features.push("");
    },

    removeFeature(index) {
      this.features.splice(index, 1);
    },

    // ✅ Save Plan
    async savePlan() {

      if (!this.plan.mplan_name) {
        alert("Plan name required");
        return;
      }

      if (!this.plan.mplan_code) {
        alert("Plan code required");
        return;
      }

      // ✅ Convert Features → JSON
      this.plan.mplan_features = JSON.stringify(
        this.features.filter(f => f.trim() !== "")
      );

      this.loading = true;

      const res = await createPlanApi(this.plan);

      this.loading = false;

      if (!res.status) {
        this.toast.error(res.success || "Plan creation failed");
        return;
      }

      this.toast.success("Plan created successfully");

      this.closeModal();
      this.loadPlans();
    }

  }
};
</script>



<style scoped>
.admin-page {
  max-width: 1440px;
  margin: auto;
  padding: 48px;
}

.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.admin-header h1 {
  font-size: 36px;
  font-weight: 800;
}

.admin-header p {
  color: #64748b;
  margin-top: 6px;
}

/* KPIs */
.kpis {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin: 32px 0;
}

.kpi {
  background: white;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #e5e7eb;
}

.kpi p {
  font-size: 11px;
  text-transform: uppercase;
  color: #94a3b8;
  font-weight: 700;
}

.kpi h2 {
  font-size: 26px;
  font-weight: 800;
}

/* Table */
.card {
  background: white;
  border-radius: 24px;
  padding: 32px;
  border: 1px solid #e5e7eb;
}

.plans-table {
  width: 100%;
  border-collapse: collapse;
}

.plans-table th,
.plans-table td {
  padding: 14px;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
}

.sub {
  font-size: 12px;
  color: #94a3b8;
}

/* Status */
.status-pill {
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 999px;
  font-weight: 800;
  text-transform: uppercase;
}

.status-pill.active {
  background: #ecfdf5;
  color: #047857;
}

.status-pill.deactive {
  background: #f1f5f9;
  color: #475569;
}

/* Actions */
.actions {
  display: flex;
  gap: 8px;
}

.primary-btn {
  background: #0f172a;
  color: white;
  padding: 8px 14px;
  border-radius: 12px;
  font-weight: 700;
}

.ghost-btn {
  background: #f1f5f9;
  padding: 8px 14px;
  border-radius: 12px;
  font-weight: 700;
}

.danger-btn {
  background: #991b1b;
  color: white;
  padding: 8px 14px;
  border-radius: 12px;
  font-weight: 700;
}

/* Empty */
.empty {
  padding: 24px;
  text-align: center;
  color: #64748b;
}

/* Mobile */
@media (max-width: 900px) {
  .kpis {
    grid-template-columns: 1fr;
  }

  .admin-page {
    padding: 24px;
  }
}

/* ===============================
   ADMIN MEMBERSHIP PLANS – MOBILE
   =============================== */
@media (max-width: 640px) {

  /* Page padding */
  .admin-page {
    padding: 20px 16px 72px;
  }

  /* Header */
  .admin-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .admin-header h1 {
    font-size: 26px;
    line-height: 1.2;
  }

  .admin-header p {
    font-size: 14px;
  }

  .admin-header .primary-btn {
    width: 100%;
    text-align: center;
  }

  /* KPIs */
  .kpis {
    grid-template-columns: 1fr;
    gap: 12px;
    margin: 20px 0;
  }

  .kpi {
    padding: 16px;
    border-radius: 14px;
  }

  .kpi h2 {
    font-size: 22px;
  }

  /* Card */
  .card {
    padding: 16px;
    border-radius: 18px;
  }

  /* Table → stacked cards */
  .plans-table thead {
    display: none;
  }

  .plans-table,
  .plans-table tbody,
  .plans-table tr,
  .plans-table td {
    display: block;
    width: 100%;
  }

  .plans-table tr {
    padding: 14px 0;
    border-bottom: 1px solid #f1f5f9;
  }

  .plans-table td {
    padding: 6px 0;
    border: none;
    font-size: 14px;
  }

  .plans-table td strong {
    font-size: 15px;
  }

  .sub {
    font-size: 12px;
  }

  /* Status pill */
  .status-pill {
    font-size: 10px;
    padding: 4px 8px;
  }

  /* Actions */
  .actions {
    flex-direction: column;
    gap: 6px;
    margin-top: 8px;
  }

  .primary-btn,
  .ghost-btn,
  .danger-btn {
    width: 100%;
    text-align: center;
    padding: 10px 14px;
  }

  /* Empty state */
  .empty {
    font-size: 14px;
    padding: 20px 10px;
  }
}
/* ===============================
   MODAL OVERLAY
   =============================== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  animation: fadeIn 0.25s ease;
}

/* ===============================
   MODAL CARD
   =============================== */
.modal-card {
  width: 420px;
  max-width: 95%;
  background: white;
  border-radius: 18px;
  padding: 26px;
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.18);
  border: 1px solid #f1f5f9;
  animation: slideUp 0.25s ease;
}

/* Title */
.modal-card h3 {
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 18px;
  color: #0f172a;
}

/* ===============================
   INPUTS
   =============================== */
.modal-card input,
.modal-card select {
  width: 100%;
  margin-bottom: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  font-size: 14px;
  font-weight: 600;
  outline: none;
  transition: 0.2s ease;
}

.modal-card input:focus,
.modal-card select:focus {
  border-color: black;
  background: white;
  box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.05);
}

/* ===============================
   ACTION BUTTONS
   =============================== */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

/* Buttons inherit your theme */
.modal-actions .ghost-btn {
  background: #f1f5f9;
  border-radius: 10px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 700;
}

.modal-actions .primary-btn {
  border-radius: 10px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 700;
}

/* ===============================
   ANIMATIONS
   =============================== */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    transform: translateY(10px) scale(0.98);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
.features-box {
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 12px;
}

.features-box label {
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  display: block;
  margin-bottom: 10px;
}

.feature-row {
  display: flex;
  gap: 6px;
  margin-bottom: 6px;
}

.feature-row input {
  flex: 1;
  margin-bottom: 0;
}

.remove-btn {
  background: #fee2e2;
  border: none;
  border-radius: 10px;
  width: 34px;
  cursor: pointer;
}

.add-feature-btn {
  width: 100%;
  margin-top: 6px;
  background: black;
  color: white;
  border-radius: 10px;
  padding: 8px;
  font-size: 12px;
  font-weight: 700;
}
/* ===============================
   MODAL GRID PATCH (2 PER ROW)
   =============================== */

.modal-card {
  width: 520px;              /* slightly wider for 2 columns */
  max-width: 95%;
  padding: 22px;             /* tighter spacing */
  
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  
  max-height: 85vh;          /* prevents tall modal */
  overflow-y: auto;
}

/* Title full width */
.modal-card h3 {
  grid-column: 1 / -1;
  margin-bottom: 6px;
}

/* Inputs & selects tighter */
.modal-card input,
.modal-card select {
  margin-bottom: 0;
  padding: 11px 12px;
  font-size: 13.5px;
}

/* Features box full width */
.features-box {
  grid-column: 1 / -1;
  margin-top: 4px;
}

/* Feature rows stay single column */
.feature-row {
  display: flex;
}

/* Actions full width */
.modal-actions {
  grid-column: 1 / -1;
  margin-top: 6px;
}

/* Buttons slightly compact */
.modal-actions .ghost-btn,
.modal-actions .primary-btn {
  padding: 8px 14px;
  font-size: 13px;
}
.sub {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
}

.pill {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.pill.ok {
  background: #dcfce7;
  color: #166534;
}

.pill.muted {
  background: #f1f5f9;
  color: #64748b;
}
/* =========================
   TABLE POLISH
   ========================= */

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  background: #f8fafc;
}

th {
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-align: left;
  padding: 14px 16px;
  border-bottom: 1px solid #e5e7eb;
  white-space: nowrap;
}

td {
  padding: 16px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 14px;
  vertical-align: middle;
}

tbody tr:hover {
  background: #f8fafc;
}

/* =========================
   COLUMN WIDTH CONTROL
   ========================= */

td:first-child {
  min-width: 220px;
}

td:last-child {
  width: 90px;
}

/* =========================
   SUBTEXT
   ========================= */

.sub {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 3px;
}

/* =========================
   PILLS
   ========================= */

.pill {
  font-size: 11px;
  padding: 5px 10px;
  border-radius: 999px;
  font-weight: 600;
}

.pill.ok {
  background: #ecfdf5;
  color: #059669;
}

.pill.muted {
  background: #f1f5f9;
  color: #64748b;
}

/* =========================
   STATUS PILL
   ========================= */

.status-pill {
  font-size: 11px;
  padding: 6px 12px;
  border-radius: 999px;
  font-weight: 700;
  text-transform: capitalize;
}

.status-pill.active {
  background: #ecfdf5;
  color: #059669;
}

.status-pill.disabled {
  background: #f1f5f9;
  color: #64748b;
}

/* =========================
   BUTTON ALIGNMENT
   ========================= */

.ghost-btn {
  font-size: 12px;
  padding: 6px 12px;
}

</style>
